export default __webpack_public_path__ + "img/portal.eb71e262.jpg";